import { gql } from 'apollo-angular';

export const SWITCH_APTITUDE_ASSIGNED_ORG = gql`
  mutation SwitchAptitudeAssignedOrg(
    $aptitudeToken: String!
    $aptitudeOrgId: Long
  ) {
    switchAptitudeAssignedOrg(
      input: { aptitudeToken: $aptitudeToken, aptitudeOrgId: $aptitudeOrgId }
    ) {
      token
    }
  }
`;

export type SwitchAptitudeAssignedOrgVariables = {
  aptitudeToken: string;
  aptitudeOrgId?: number;
};
